import { PrismaClient } from "@prisma/client";
import {
  hashPasswordMiddleware,
  softDeleteMiddleware,
  updateMiddleware,
} from "./middlewares/prisma";
import {
  IAssessment,
  AssessmentPost,
  AssessmentsResponse,
} from "./models/assessments";
import { IRule, RuleBasic, OrderedRulesTemplates } from "./models/rules";
import {
  MindPrintProfileReport,
  MindPrintProfileTemplate,
  IReport,
  ReportSkillContent,
  ReportSkillSummary,
  ReportContent,
  IReportFlag,
  ReasoningGroups,
  MemoryGroups,
} from "./models/reports";
import {
  IScores,
  Skills,
  SkillsBasic,
  Skill,
  SkillBasic,
  SkillCategory,
  IScore,
  ScoreRangeValues,
  ScoreRanges,
} from "./models/scores";
import {
  IOrganization,
  OrganizationPost,
  OrganizationsResponse,
} from "./models/admin/organizations";
import { ISite, SitePost, SitesResponse } from "./models/admin/sites";
import {
  ISection,
  SectionPost,
  SectionsResponse,
} from "./models/admin/sections";
import { IUser, UsersResponse } from "./models/admin/users";
import { IStudent, StudentBasic } from "./models/admin/students";
import {
  hashPassword,
  hashPasswordSync,
  comparePasswords,
} from "./utils/password";
import { CustomRuleDTO } from "./models/customRules";
import {
  CognitiveSkills,
  ComboPrimarySkillScores,
  ComboScoreDetail,
  ComboSection,
  ComboSectionScores,
  ComboSections,
  ComboSkillDetail,
  ComplexReasoningChartData,
  ExecutiveFunctionsChartData,
  MemoryAndSpeedChartData,
  NationalAverages,
  ScoreDetail,
  SectionRecommendation,
  SectionScores,
  SkillData,
  StudentInfo,
  TestPrepComboReport,
  TestPrepReport,
  XY,
} from "./models/testPrepReports";

export type {
  IAssessment,
  AssessmentPost,
  CustomRuleDTO,
  AssessmentsResponse,
  MindPrintProfileReport,
  MindPrintProfileTemplate,
  OrderedRulesTemplates,
  IOrganization,
  OrganizationPost,
  OrganizationsResponse,
  IReport,
  ReportContent,
  IReportFlag,
  ReportSkillContent,
  ReportSkillSummary,
  IRule,
  RuleBasic,
  IScore,
  ScoreRanges,
  IScores,
  ISection,
  SectionPost,
  SectionsResponse,
  ISite,
  SitePost,
  SitesResponse,
  Skill,
  SkillBasic,
  Skills,
  SkillsBasic,
  IStudent,
  StudentBasic,
  IUser,
  UsersResponse,
  CognitiveSkills,
  ComboPrimarySkillScores,
  ComboScoreDetail,
  ComboSectionScores,
  ComboSections,
  ComboSkillDetail,
  ComplexReasoningChartData,
  ExecutiveFunctionsChartData,
  MemoryAndSpeedChartData,
  NationalAverages,
  ScoreDetail,
  SectionRecommendation,
  SectionScores,
  SkillData,
  StudentInfo,
  TestPrepComboReport,
  TestPrepReport,
  XY,
};

// Export enums like this (error thrown if they are exported as "types" above)
export {
  ScoreRangeValues,
  SkillCategory,
  MemoryGroups,
  ReasoningGroups,
  ComboSection,
};

// Prisma Middleware
export const addPrismaMiddleware = async (client: PrismaClient) => {
  client.$use(hashPasswordMiddleware);
  client.$use(softDeleteMiddleware);
  client.$use(updateMiddleware);
};

// utils
export { hashPassword, hashPasswordSync, comparePasswords };

// Prisma Client
export * from "@prisma/client";
